export default {
  'en': {
    main: {
      seminar: "seminar",
      breakout: "breakout",
      participants: "participants",
      questions: "ask",
      unassigned: "unassigned",
      textchat: "chat",
      typechat: "Type a message here",
      teacher: "teacher",
      student: "student",
      facilitator: "facilitator",
      deviceSetting: "deviceSetting",
      selectAudioDevice: "Select your audio device",
      selectVideoDevice: "Select your video device",
      default: "Default",
      cancel: "Cancel",
      save: "Save",
      modalBreakoutTitle: "Go to BreakOut Room?",
      modalBreakoutTitleBody1: "Are you sure you want to go to breakout room?",
      modalBreakoutTitleBody2: "All the participants will change.",
      modalBreakoutEnter: "go to breakout room",
      modalScreenShare: "FreshVoice Screenshare Plugin Needed.",
      modalScreenShareInstall: "INSTALL PLUGIN ( Reload Browser After nstallling )",
      endTitle: "End Seminar?",
      endBody1: "Are you sure you want to END the entire call?",
      endBody2: "All the participants will go out of the seminar",
      endEnter: "end seminar",
      modalSeminarTitle: "Return to Seminar Room?",
      modalSeminarBody: "Are you sure you want to return to Seminar Room?",
      modalSeminarEnter: "return to seminar",
      modalCreateTableTitle: "Create New Table?",
      modalCreateTableName: "table name?",
      modalCreateTableEnter: "create table",
      modalCreateProhibitSameName: "This field is required. The same room name is prohibited.",
      modalAnnounceTitle: "Send announcement?",
      modalAnnounceBody: "Announcement message",
      modalAnnounceEnter: "send message",
      modalAssignTitle: "Assign all participants randomly?",
      modalAssignText: "How many people would you like to assign to one table?",
      modalAssignEnter: "Assign",
      modalDeleteTitle: "Delete Table",
      members: "members",
      delete: "delete",
      modalMoveTitle1: "Move",
      modalMoveTitle2: "to",
      modalMoveNoAssign: "Currently no assigned",
      modalMoveAssignTitle: "Currently in",
      modalMoveAssign: "Currently in this room",
      modalMoveEnter: "move here",
      modalMoveFull: "room full",
      fieldEmpty: "This field is required",
      fieldEmptyNum: "This field is required. 1~6 is valid.",
      requiredNameField: "Enter your display name",
      yourName: "John",
      yourNameFloating: "Your Name",
    }
  },
  'ja': {
    main: {
      seminar: "セミナー",
      breakout: "ディスカッション",
      participants: "参加者",
      questions: "発言申請",
      unassigned: "未割り当て",
      textchat: "チャット",
      typechat: "テキストを入力してください",
      teacher: "プレゼンター",
      student: "受講者",
      facilitator: "アシスタント",
      deviceSetting: "デバイス設定",
      selectAudioDevice: "マイクを設定してください",
      selectVideoDevice: "カメラを設定してください",
      default: "標準",
      cancel: "キャンセル",
      save: "保存",
      modalBreakoutTitle: "ディスカッションモードへの切り替え",
      modalBreakoutTitleBody1: "ディスカッションモードへ切り替えますか？グループワークを開始することができます。",
      modalBreakoutTitleBody2: " ",
      modalBreakoutEnter: "切り替え",
      modalScreenShare: "スクリーンシェアのプラグイン",
      modalScreenShareInstall: "ここをクリックしてインストールしてください(インストール後はブラウザのリロードをしてください。)",
      modalBreakoutEnter: "切り替え",
      endTitle: "セミナーの終了",
      endBody1: "セミナーを終了しますか？終了すると、録画映像の処理が開始されます。",
      endBody2: " ",
      endEnter: "セミナー終了",
      modalSeminarTitle: "セミナーモードへ戻る",
      modalSeminarBody: "セミナーモードへ戻りますか？現在の参加者のテーブル割り当て状態は保存されます。",
      modalSeminarEnter: "セミナーへ戻る",
      modalCreateTableTitle: "新しいテーブルの作成",
      modalCreateTableName: "テーブルの名前",
      modalCreateTableEnter: "作成",
      modalCreateProhibitSameName: "同じ名前のテーブル名は使用できません",
      modalAnnounceTitle: "アナウンスメッセージ",
      modalAnnounceBody: "全参加者へ送信するテキストメッセージを入力してください。",
      modalAnnounceEnter: "送信",
      modalAssignTitle: "受講者に対する、テーブルへのランダム割り当て",
      modalAssignText: "1つのテーブルに何人割り当てますか？",
      modalAssignEnter: "割り当て",
      modalDeleteTitle: "テーブルの削除",
      members: "人",
      delete: "削除",
      modalMoveTitle1: " ",
      modalMoveTitle2: "を移動させる",
      modalMoveNoAssign: "どのテーブルにも割り当てられていません",
      modalMoveAssignTitle: "現在のテーブル:",
      modalMoveAssign: "現在ここに居ます",
      modalMoveEnter: "ここへ移動",
      modalMoveFull: "満員",
      fieldEmpty: "入力してください",
      fieldEmptyNum: "1-6の数字を入力してください",
      requiredNameField: "名前を入力してください",
      yourName: "山田",
      yourNameFloating: "あなたの名前",
    }
  }
};



// WEBPACK FOOTER //
// ./src/messages.js